module.exports = __webpack_public_path__ + "static/media/home_bg_sm.62598042.gif";